'use strict';

const checkInstationSite = (path, host) => {
  if (path && path.includes("://")) {
    try {
      const url = new URL(path);
      return url.host.includes(host || "tvbanywhere.com");
    } catch (error) {
      console.error(error);
      return false;
    }
  } else if (path && !path.includes("://")) {
    return true;
  }
  return false;
};
function filterSpecial(stg) {
  try {
    return stg.replaceAll(
      /[`~!@#$^&*()=|{}':;',\\\[\]\.<>\/?~！@#￥……&*（）——|{}【】'；：""'。，、？《》%\s]/g,
      "-"
    );
  } catch (error) {
    return stg;
  }
}
function getUuid() {
  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function(c) {
    const r = Math.random() * 16 | 0, v = c == "x" ? r : r & 3 | 8;
    return v.toString(16);
  });
}
function getDeviceInfo() {
  const ua = navigator.userAgent.toLowerCase();
  const testUa = (regexp) => regexp.test(ua);
  if (testUa(/windows|win32|win64|wow32|wow64/g)) {
    return {
      id: 2,
      name: "PC( Windows )",
      code: "Windows"
    };
  } else if (testUa(/macintosh|macintel/g)) {
    return {
      id: 3,
      name: "PC( MAC )",
      code: "Mac"
    };
  } else if (testUa(/x11/g)) {
    return {
      id: 1,
      name: "PC( Linux )",
      code: "Linux"
    };
  } else if (testUa(/android|adr/g)) {
    return {
      id: 11,
      name: "Android",
      code: "Android"
    };
  } else if (testUa(/ios/g)) {
    return {
      id: 48,
      name: "IOS",
      code: "IOS"
    };
  }
  return {
    id: 0,
    name: "Unknown",
    code: "Unknown"
  };
}
const getMainHost = () => {
  const key = `mh_${Math.random()}`;
  const keyR = new RegExp(`(^|;)\\s*${key}=12345`);
  const expiredTime = new Date(0);
  const domain = document.domain;
  const domainList = domain.split(".");
  const urlItems = [];
  urlItems.unshift(domainList.pop());
  while (domainList.length) {
    urlItems.unshift(domainList.pop());
    const mainHost = urlItems.join(".");
    const cookie = `${key}=${12345};domain=.${mainHost}`;
    document.cookie = cookie;
    if (keyR.test(document.cookie)) {
      document.cookie = `${cookie};expires=${expiredTime}`;
      return mainHost;
    }
  }
};
const debounce = (func, time, immediate = false) => {
  let timer = null;
  return (...args) => {
    if (timer)
      clearInterval(timer);
    if (immediate) {
      if (!timer)
        func.apply(void 0, args);
      timer = window.setTimeout(() => {
        timer = null;
      }, time);
    } else {
      timer = window.setTimeout(() => {
        func.apply(void 0, args);
      }, time);
    }
  };
};
const getPublishTimestamp = () => {
  const appPublishTime = window.appPublishTime;
  if (appPublishTime) {
    try {
      return (appPublishTime == null ? void 0 : appPublishTime.length) === 13 ? appPublishTime : new Date(appPublishTime).getTime();
    } catch (error) {
      return new Date().getTime();
    }
  }
  return new Date().getTime();
};
const waitForEvent = (name, action, target) => {
  target.addEventListener(
    name,
    function() {
      action(arguments[0]);
    },
    false
  );
};
const arrayToString = (array) => {
  const uint16array = new Uint16Array(array.buffer);
  return String.fromCharCode.apply(null, uint16array);
};
const extractContentId = (initData) => {
  const kuri = arrayToString(initData);
  const kuri_parts = kuri.split("://", 2);
  const kuri_parts2 = kuri_parts[1].split("?", 2);
  const contentId = kuri_parts2[0];
  return contentId;
};
const stringToArray = (string) => {
  const buffer = new ArrayBuffer(string.length * 2);
  const array = new Uint16Array(buffer);
  for (let i = 0, strLen = string.length; i < strLen; i++) {
    array[i] = string.charCodeAt(i);
  }
  return array;
};
const concatInitDataIdAndCertificate = (initData, id, cert) => {
  if (typeof id == "string")
    id = stringToArray(id);
  let offset = 0;
  const buffer = new ArrayBuffer(initData.byteLength + 4 + id.byteLength + 4 + cert.byteLength);
  const dataView = new DataView(buffer);
  const initDataArray = new Uint8Array(buffer, offset, initData.byteLength);
  initDataArray.set(initData);
  offset += initData.byteLength;
  dataView.setUint32(offset, id.byteLength, true);
  offset += 4;
  const idArray = new Uint16Array(buffer, offset, id.length);
  idArray.set(id);
  offset += idArray.byteLength;
  dataView.setUint32(offset, cert.byteLength, true);
  offset += 4;
  const certArray = new Uint8Array(buffer, offset, cert.byteLength);
  certArray.set(cert);
  return new Uint8Array(buffer, 0, buffer.byteLength);
};
const base64EncodeUint8Array = (input) => {
  const keyStr = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";
  let output = "";
  let chr1, chr2, chr3, enc1, enc2, enc3, enc4;
  let i = 0;
  while (i < input.length) {
    chr1 = input[i++];
    chr2 = i < input.length ? input[i++] : Number.NaN;
    chr3 = i < input.length ? input[i++] : Number.NaN;
    enc1 = chr1 >> 2;
    enc2 = (chr1 & 3) << 4 | chr2 >> 4;
    enc3 = (chr2 & 15) << 2 | chr3 >> 6;
    enc4 = chr3 & 63;
    if (isNaN(chr2)) {
      enc3 = enc4 = 64;
    } else if (isNaN(chr3)) {
      enc4 = 64;
    }
    output += keyStr.charAt(enc1) + keyStr.charAt(enc2) + keyStr.charAt(enc3) + keyStr.charAt(enc4);
  }
  return output;
};
const base64DecodeUint8Array = (input) => {
  const raw = window.atob(input);
  const rawLength = raw.length;
  console.log(rawLength);
  const array = new Uint8Array(new ArrayBuffer(rawLength));
  for (let i = 0; i < rawLength; i++)
    array[i] = raw.charCodeAt(i);
  return array;
};

exports.arrayToString = arrayToString;
exports.base64DecodeUint8Array = base64DecodeUint8Array;
exports.base64EncodeUint8Array = base64EncodeUint8Array;
exports.checkInstationSite = checkInstationSite;
exports.concatInitDataIdAndCertificate = concatInitDataIdAndCertificate;
exports.debounce = debounce;
exports.extractContentId = extractContentId;
exports.filterSpecial = filterSpecial;
exports.getDeviceInfo = getDeviceInfo;
exports.getMainHost = getMainHost;
exports.getPublishTimestamp = getPublishTimestamp;
exports.getUuid = getUuid;
exports.stringToArray = stringToArray;
exports.waitForEvent = waitForEvent;
//# sourceMappingURL=index.js.map
